import SegnalazioniMock from "../../mocks/SegnalazioniListMock";
import { SegnalazioneLightList } from "../../models/objs/SegnalazioneLight";
import { RestService } from "../../RestService";
import SegnalazioneMockInCompilazione from "../../mocks/SegnalazioneMockInCompilazione";
import SegnalazioneChoiceLists from "../../mocks/SegnalazioneChoiceLists";
import Allegati from "../../mocks/AllegatiMock";
import { Setting } from "../../../shared/utils/Settings";
import { Segnalazione } from "../../models/objs/Segnalazione";
import { DELAY } from "../../../shared/utils/Utils";
import { UserInfo } from "../../models/output-objs/UserInfo";
import { AxiosInstance } from "axios";
import ServerInstanceSingleton from "../../server-istances/Stor-Server/ServerInstance";
import { LineOfInquiryList } from "../../models/objs/LineOfInquiry";
import { LineOfInquiryOutput } from "../../models/output-objs/LineOfInquiryOutput";
import AllegatiStampone from "../../mocks/AllegatiStamponeMock";
import { TriageElements } from "../../models/output-objs/TriageElementsOutput";
import { TriageLevels } from "../../models/output-objs/TriageLevelsOutput";
import { ElementListInput } from "../../models/input-objs/ElementListInput";


export class SegnalazioniService extends RestService {
    public apiVersion = 'v1';
    static getChoiceList: any;
    private serverInstance: AxiosInstance;
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(){
        super();
        const server = ServerInstanceSingleton.getInstance();
        this.serverInstance =  server.getAxiosInstance();
    }

    public async getSegnalazioni():Promise<SegnalazioneLightList>{
        await DELAY(3000);
        return SegnalazioniMock;
    }

    public getSegnalazioneById(id : string) {
        switch (id) {
            case "2022_0001":
                return SegnalazioneMockInCompilazione
            // case "2022_0002":
            //     return SegnalazioneMockProtocollata
            default :
                return SegnalazioneMockInCompilazione
        }
    }

    public getChoiceLists() {
        return SegnalazioneChoiceLists
    }

    public getAllegati(){
        return Allegati
    }

    public getStamponeFormat(){
        return AllegatiStampone
    }

    public async sendSegnalazione(id : any): Promise<any> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return true;
        }
        else{
            try{
                return await this.serverInstance.get(
                    this.SEGNALAZIONI_SERVICE_BASE_URL + '/submit/' + id,
                    {headers: this.createHttpGenericOptions()}
                );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async getRettifica(id : any): Promise<any> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return true;
        }
        else{
            return await this.serverInstance.get(
            this.SEGNALAZIONI_SERVICE_BASE_URL + '/amend/' + id,
            {headers: this.createHttpGenericOptions()}
            );
        }
    }

    public async sendRettifica(segnalazione: any, id : any, newId : any): Promise<Segnalazione | undefined> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.get(
                    this.SEGNALAZIONI_SERVICE_BASE_URL + '/amend/' + id + '/' + newId,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async getExtraInfo(id : any): Promise<any> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            return await this.serverInstance.get(
            this.SEGNALAZIONI_SERVICE_BASE_URL + '/extra/' + id,
            {headers: this.createHttpGenericOptions()}
            );
        }
    }

    public async downloadStampone(id : any): Promise<any> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            return await this.serverInstance.get(
            this.SEGNALAZIONI_SERVICE_BASE_URL + '/pdf/' + id,
            {headers: this.createHttpGenericOptions()}
            );
        }
    }

    public async addFunzionario(id : any, singleFunz : any): Promise<Segnalazione | undefined> {
        const jsonFunz = {
            idStor : id,
            idFunzionario : singleFunz.idFunzionario,
            idAssignment : singleFunz.idAssignment
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/addFunzionario',
                jsonFunz,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async removeAllFunzionari(id : string): Promise<LineOfInquiryList> {
        return await this.serverInstance.delete(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/removeAllFunzionario/' + id,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async addFunzionarioLoi(id : any, singleFunz : any): Promise<Segnalazione | undefined> {
        const jsonFunz = {
            idLoi : id,
            idFunzionario : singleFunz.idFunzionario,
            idAssignment : singleFunz.idAssignment
        }
        try{
            return await this.serverInstance.post(
                this.LOI_SERVICE_BASE_URL + '/addFunzionario',
                jsonFunz,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async removeFunzionario(id : any, idFunz: number, idAsgnm : number): Promise<Segnalazione | undefined> {
        try{
            return await this.serverInstance.delete(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/removeFunzionario/' + id + '/' + idFunz + '/' + idAsgnm,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async removeFunzionarioLoi(id : any, idFunz: number, idAsgnm : number): Promise<Segnalazione | undefined> {
        try{
            return await this.serverInstance.delete(
                this.LOI_SERVICE_BASE_URL + '/removeFunzionario/' + id + '/' + idFunz + '/' + idAsgnm,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async sendExtraInfo(arricchimento: any, id : any): Promise<Segnalazione | undefined> {
        const jsonArrichimento = JSON.stringify(arricchimento);
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/extra/' + id,
                jsonArrichimento,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async assignFunz(arricchimento: any, id : any): Promise<Segnalazione | undefined> {
        const jsonArrichimento = JSON.stringify(arricchimento);
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/assign/' + id,
                jsonArrichimento,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async toComplete(arricchimento: any, id : any): Promise<Segnalazione | undefined> {
        const jsonArrichimento = JSON.stringify(arricchimento);
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/toComplete/' + id,
                jsonArrichimento,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async riprendi(id : string): Promise<Segnalazione | undefined> {
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/ripresa/' + id,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async getFilenetId(folderReq : string): Promise<any | undefined> {
        let jsonRequest = {
            folder : folderReq,
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/getFolderId',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async getFilenetStructure(id: string, loiName?: string): Promise<any | undefined> {
        try {
            const url = `${this.SEGNALAZIONI_SERVICE_BASE_URL}/folder/${id}${loiName ? `?internalLoiId=${loiName}` : ''}`;
            return await this.serverInstance.get(url, {
            headers: this.createHttpGenericOptions(),
            });
        } catch (error) {
            return undefined;
        }
    }

    public async nextStepState(id : string): Promise<string[] | undefined> {
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/allowedStates/' + id,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async nextStepMabState(id : string): Promise<string[] | undefined> {
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/mabNote/allowedStatesNotaMab/' + id,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async verificaConsegnaBozza(id : string): Promise<string[]| undefined> {
        let jsonRequest = {
            idStor : id,
            state : 'ANALISI_CONCLUSE'
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/checkConsegnaBozzaNotaAiRevisori',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async nonPortareInComitato(id : string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            state : 'ANALISI_CONCLUSE'
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/casoDaNonPortareInComitato',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async giaDiscussoInComitato(id : string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            state : 'ANALISI_CONCLUSE'
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/casoGiaDiscussoInComitato',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async trasmettereABM(id : string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            state : 'ANALISI_CONCLUSE'
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/casoDaTrasmettereAdABM',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async consegnaBozzaNota(id : string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            state : 'ANALISI_CONCLUSE',
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/consegnaBozzaNotaAiRevisori',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async invioNotaUri(id : string, data: string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            state : 'ANALISI_CONCLUSE',
            forwardingUriDate : data
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/invioNotaUri',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async changeStateFunz(id : string, state : string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            state : state
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/changeStorState',
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async changeFlagDemaco(id: string,value:boolean): Promise<any> {
        let jsonRequest = {
            demacoAssigned : value
        }
        try{
            return await this.serverInstance.put(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/demacoAssignment/' + id,
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async changeStateMAB(idNota: number, id : string, fromState: string, toState : string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            currentState : fromState,
            nextState: toState
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/mabNote/changeState/' + idNota,
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async reopenStor(id: string): Promise<any> {
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/' + id + '/rollback',
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async reopenStorMabNote(id: string): Promise<any> {
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/mabNote/rollback/' + id,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async changeStateMABComitato(notaMab: any, id : string, fromState: string, toState : string, path:string): Promise<Segnalazione | undefined> {
        let jsonRequest = {
            idStor : id,
            currentState : fromState,
            nextState: toState,
            title: notaMab['titoloNota'],
            proposedState: notaMab['esitoProposto'],
            macrocategoriesId: notaMab['macrocategoriesId'],
            numeroPredisposizione: notaMab['numeroPredisposizione'],
            numeroRiunione: notaMab['numeroRiunione'],
            dataPrimaRiunione: notaMab['dataPrimaRiunione'],
            noteSegreteria: notaMab['noteSegreteria'],
            p8MabLink: path
        }
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/mabNote/changeState/' + notaMab['idNota'],
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async saveNoteFunz(id : string, form : {[key : string] : any}): Promise<Segnalazione | undefined> {
        let jsonRequest = JSON.stringify(form);
        try{
            return await this.serverInstance.post(
                this.SEGNALAZIONI_SERVICE_BASE_URL + '/saveFormAssign/' + id,
                jsonRequest,
                {headers: this.createHttpGenericOptions()}
                );
        }
        catch(error){
            return undefined;
        }
    }

    public async closeStor(arricchimento: any, id : any): Promise<Segnalazione | undefined> {
        const jsonArrichimento = JSON.stringify(arricchimento);
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.post(
                    this.SEGNALAZIONI_SERVICE_BASE_URL + '/closeStor/' + id,
                    jsonArrichimento,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async cloneStor(id : any): Promise<any> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return true;
        }
        else{
            return await this.serverInstance.get(
            this.SEGNALAZIONI_SERVICE_BASE_URL + '/clone/' + id,
            {headers: this.createHttpGenericOptions()}
            );
        }
    }

    public async getHistory(id : any): Promise<any> {
        return await this.serverInstance.get(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/history/' + id,
        {headers: this.createHttpGenericOptions()}
        );
        
    }

    public modifySegnalazione() {
        return SegnalazioniMock
    }

    // public async getListStor(): Promise<SegnalazioneLightList> {
    //     if(Setting.OFFLINE_MODE){
    //         await DELAY(3000);
    //         return SegnalazioniMock;
    //     }
    //     else{
    //         return await this.serverInstance.get(
    //         this.SEGNALAZIONI_SERVICE_BASE_URL,
    //         {headers: this.createHttpGenericOptions()}
    //         );
    //     }
    // }

    public async getLineOfInquiry(): Promise<LineOfInquiryList> {
        return await this.serverInstance.get(
        this.LOI_SERVICE_BASE_URL + '/getAllLineOfInquiry',
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async deleteLineOfInquiry(id : string): Promise<LineOfInquiryList> {
        return await this.serverInstance.delete(
        this.LOI_SERVICE_BASE_URL + '/' + id,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async createLineOfInquiry(loi : any): Promise<LineOfInquiryList> {
        let loiJson = JSON.stringify(loi);
        return await this.serverInstance.post(
        this.LOI_SERVICE_BASE_URL,
        loiJson,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async assignToLineOfInquiry(loi : any, idStor : any, assign:boolean): Promise<LineOfInquiryList> {
        let loiJson = JSON.stringify(loi);
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/assignToLoi/' + idStor + '?reassign=' + assign,
        loiJson,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async removeToLineOfInquiry(loi : any, idStor : any): Promise<LineOfInquiryList> {
        let loiJson = JSON.stringify(loi);
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/removeAssignToLoi/' + idStor,
        loiJson,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async updateLineOfInquiry(loi : any): Promise<LineOfInquiryList> {
        let loiJson = JSON.stringify(loi);
        return await this.serverInstance.put(
        this.LOI_SERVICE_BASE_URL,
        loiJson,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async getStorLineOfInquiry(id : string): Promise<any> {
        return await this.serverInstance.get(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/getAllStorAssociatedToTheLoi/' + id,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async getFilteredListStor(filter : any, userType : any): Promise<SegnalazioneLightList> {
        let urlString = '/filteredStor'
        switch(userType){
            case 'funzionario':urlString = '/filteredStor/funzionario';break;
            case 'responsabile':urlString = '/filteredStor/responsabileUfficio';break;
            case 'revisore':urlString = '/filteredStor/revisore';break;
        }
        let filterJson = JSON.stringify(filter);
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + urlString,
        filterJson,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async sendFascicolo(idStor: string, fascicolo : string): Promise<SegnalazioneLightList> {
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/assignFascicolo/' + idStor + '/' + fascicolo,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async sendNotaMab(idStor: string, nota : string): Promise<SegnalazioneLightList> {
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/assignUriNoteProtocolNumber/' + idStor + '/' + nota,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async sendNotaProtocolMab(idNota : string, id : string, protocolNumber: string): Promise<SegnalazioneLightList> {
        const jsonProtocolNota = {
            idStor : id,
            mabProtocolNumber : protocolNumber,
        }
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/mabNote/saveMabProtocolNumber/' + idNota,
        jsonProtocolNota,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async sendNotaNoteMab(idNota : string, id : string, note: string): Promise<SegnalazioneLightList> {
        const jsonProtocolNota = {
            idStor : id,
            textMabNote : note,
        }
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + '/mabNote/saveTextNotaMab/' + idNota,
        jsonProtocolNota,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async getExportStor(filter : any, userType:any): Promise<any> {
        let urlString = '/excel/generateExcelStor'
        switch(userType){
            case 'funzionario':urlString = '/excel/generateExcelStor/funzionario';break;
            case 'responsabile':urlString = '/excel/generateExcelStor/responsabileUfficio';break;
        }
        let filterJson = {}
        if(filter)
            filterJson = JSON.stringify(filter);
        return await this.serverInstance.post(
        this.SEGNALAZIONI_SERVICE_BASE_URL + urlString,
        filterJson,
        {headers: this.createHttpGenericOptions(),   responseType: 'arraybuffer',
        responseEncoding: 'binary', }
        )
    }

    public async getReportAssegnazione(userType:string|undefined, filter : any): Promise<any> {
        let urlString = '/admin'
        switch(userType){
            case 'funzionario':urlString = '/funzionario';break;
            case 'responsabile':urlString = '/responsabileUfficio';break;
        }
        let filterJson = {}
        if(filter)
            filterJson = JSON.stringify(filter);
        return await this.serverInstance.post(
        this.REPORT_SERVICE_BASE_URL + '/assegnazioni/' + urlString,
        filterJson,
        {headers: this.createHttpGenericOptions(),   responseType: 'arraybuffer',
        responseEncoding: 'binary', }
        )
    }
    
    public async getReportAssegnazioneAperte(userType:string|undefined, filter : any): Promise<any> {
        let urlString = '/admin'
        switch(userType){
            case 'funzionario':urlString = '/funzionario';break;
            case 'responsabile':urlString = '/responsabileUfficio';break;
        }
        let filterJson = {}
        if(filter)
            filterJson = JSON.stringify(filter);
        return await this.serverInstance.post(
        this.REPORT_SERVICE_BASE_URL + '/assegnazioniAperte/' + urlString, filterJson,
        {headers: this.createHttpGenericOptions(),   responseType: 'arraybuffer',
        responseEncoding: 'binary', }
        )
    }

    public async getReportAssegnazioneMax(userType:string|undefined, filter : any): Promise<any> {
        let urlString = '/admin'
        switch(userType){
            case 'funzionario':urlString = '/funzionario';break;
            case 'responsabile':urlString = '/responsabileUfficio';break;
        }
        let filterJson = {}
        if(filter)
            filterJson = JSON.stringify(filter);
        return await this.serverInstance.post(
        this.REPORT_SERVICE_BASE_URL + '/assegnazioniAperteMax/' + urlString, filterJson,
        {headers: this.createHttpGenericOptions(),   responseType: 'arraybuffer',
        responseEncoding: 'binary', }
        )
    }

    public async getReportMacro(userType:string|undefined, filter : any): Promise<any> {
        let urlString = '/admin'
        switch(userType){
            case 'funzionario':urlString = '/funzionario';break;
            case 'responsabile':urlString = '/responsabileUfficio';break;
        }
        let filterJson = {}
        if(filter)
            filterJson = JSON.stringify(filter);
        return await this.serverInstance.post(
        this.REPORT_SERVICE_BASE_URL + '/macrocategories' + urlString, filterJson,
        {headers: this.createHttpGenericOptions(),   responseType: 'arraybuffer',
        responseEncoding: 'binary', }
        )
    }

    public async getUserInfo(): Promise<UserInfo> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return {};
        }
        else{
            return await this.serverInstance.get(
            this.SEGNALAZIONI_SERVICE_BASE_URL + '/userinfo',
            {headers: this.createHttpGenericOptions()}
            );
        }
    }

    public async getTriageElements(suspicionTypeId: number):Promise<TriageElements>{
        return await this.serverInstance.get(
            this.TRIAGE_SERVICE_BASE_URL + '/elements/' + suspicionTypeId,
            {headers: this.createHttpGenericOptions()}
        )
    }

    public async getTriageLevels(suspicionTypeId: number):Promise<TriageLevels>{
        return await this.serverInstance.get(
            this.TRIAGE_SERVICE_BASE_URL + '/levels/' + suspicionTypeId,
            {headers: this.createHttpGenericOptions()}
        )
    }

    public async sendTriageResult(elements : ElementListInput[]):Promise<any>{
        let elementsJson = JSON.stringify(elements);
        return await this.serverInstance.post(
        this.TRIAGE_SERVICE_BASE_URL + '/score_details',
        elementsJson,
        {headers: this.createHttpGenericOptions()}
        );
    }

    public async getScoreDetails(id:string): Promise<any | undefined>{
        return await this.serverInstance.get(
            this.TRIAGE_SERVICE_BASE_URL + '/score_details/' + id,
            {headers: this.createHttpGenericOptions()}
        )
    }

    public async editStor(segnalazione: Segnalazione): Promise<Segnalazione | undefined> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.put(
                    this.SEGNALAZIONI_SERVICE_BASE_URL,
                    segnalazione,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async saveStor(segnalazione: any): Promise<Segnalazione | undefined> {
        const jsonStor = JSON.stringify(segnalazione);
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.post(
                    this.SEGNALAZIONI_SERVICE_BASE_URL,
                    jsonStor,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async amendStor(segnalazione: any): Promise<Segnalazione | undefined> {
        const jsonStor = JSON.stringify(segnalazione);
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.post(
                    this.SEGNALAZIONI_SERVICE_BASE_URL,
                    jsonStor,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async getAmendStorByID(id: number): Promise<Segnalazione | undefined> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.get(
                    this.SEGNALAZIONI_SERVICE_BASE_URL + '/amend/' + id,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async amendStorByID(id: number, segnalazione: Segnalazione): Promise<Segnalazione | undefined> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.post(
                    this.SEGNALAZIONI_SERVICE_BASE_URL + '/amend/' + id,
                    segnalazione,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async deleteStorByID(id: string): Promise<Segnalazione | undefined> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined
        }
        else{
            return await this.serverInstance.delete(
            this.SEGNALAZIONI_SERVICE_BASE_URL + '/' + id,
            {headers: this.createHttpGenericOptions()}
            );
        }
    }

    public async submitStor(id: number): Promise<Segnalazione | undefined> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.get(
                    this.SEGNALAZIONI_SERVICE_BASE_URL + '/submit/' + id,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){
                return undefined;
            }
        }
    }

    public async getStorByID(id: any): Promise<Segnalazione | undefined> {
        if(Setting.OFFLINE_MODE){
            await DELAY(3000);
            return undefined;
        }
        else{
            try{
                return await this.serverInstance.get(
                    this.SEGNALAZIONI_SERVICE_BASE_URL + '/' + id,
                    {headers: this.createHttpGenericOptions()}
                    );
            }
            catch(error){   
                return undefined;
            }
        }
    }

}